import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const login = async (user: String, password: String): Promise<AxiosResponse> =>
  AxiosInstance.post('login', { user, password });
